import rest from "refractor/rest";
export default rest;